export const HACKATAO = "https://hackatao.com/";
export const NFTSTUDIOS = "https://nftstudios.io/";
export const DISCORD = "https://discord.gg/invite/Hackatao";
export const INSTAGRAM = "https://instagram.com/hackatao";
export const TWITTER = "https://twitter.com/Hackatao";
export const EMAIL = "mailto:queenskings@hackatao.com";
export const MEDIUM = "https://medium.com/@hackatao/freeze-monetize-your-queens-kings-fdfe7a8cf557";
